import styled from "styled-components";

export const SubTitle = styled.p`
    line-height: 20px;
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 5px;
    padding-bottom: 33px;
    position: relative;
    text-align: center;
    &::after{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: #ff7f00;
        bottom: 0;
        right: 50%;
        transform: translateX(50%);
    }
`